import { SocialAccountStatus } from '@anytag/graphql';
import { Button, Form } from '@anytag/shared-atoms';
import { SupportedSocialMediaType } from '@anytag/shared-types';
import { SocialMediaInputFieldProps, SocialMediaInputField } from '../../../../shared';
import { EditAccountButton } from '../EditAccountButton/template';
import { SocialNetworkAccount } from '../schema-types';

export interface SocialMediaInputFieldActionProps extends SocialMediaInputFieldProps {
  influencerId?: number;
  onDelete?: () => void;
  account?: SocialNetworkAccount;
}

export const SocialMediaInputFieldAction = ({
  title,
  account,
  onDelete,
  socialMedia,
  influencerId,
  ...inputProps
}: SocialMediaInputFieldActionProps) => {
  const hideEditButton =
    !account?.username ||
    !account?.socialAccountId ||
    (account?.status !== SocialAccountStatus.SCRAPING && socialMedia !== SupportedSocialMediaType.TIKTOK);

  const hasEditButton =
    influencerId &&
    !hideEditButton &&
    ![SupportedSocialMediaType.DOUYIN, SupportedSocialMediaType.XHS].includes(socialMedia as SupportedSocialMediaType);

  return (
    <div css={{ gap: '8px', display: 'flex', alignItems: 'flex-end', marginBottom: '8px' }}>
      <SocialMediaInputField title={title} socialMedia={socialMedia} {...inputProps} />

      {hasEditButton ? (
        <Form.Field className="flex-none">
          <EditAccountButton
            inputProps={{ title }}
            socialMedia={socialMedia}
            influencerId={influencerId}
            socialAccountId={account.socialAccountId}
          />
        </Form.Field>
      ) : null}

      {onDelete ? (
        <Form.Field className="flex-none self-end">
          <Button variant="outline" prefixIcon={{ icon: 'trash', size: 16 }} onClick={onDelete} />
        </Form.Field>
      ) : null}
    </div>
  );
};
